import { createSelector } from '@reduxjs/toolkit';

import type { SliceStateFromReducer } from 'shared/types';

import type { scenarioSlice } from 'entities/scenario';
import { autosendDisabledScenarios } from 'entities/scenario/config';

export type TScenarioState = SliceStateFromReducer<typeof scenarioSlice>;

export const getScenario = (state: TScenarioState) => state.scenario.currentStep;
export const getScenarioContent = createSelector(getScenario, (step) => step?.content);
export const getScenarioLoading = (state: TScenarioState) => state.scenario.isLoading;
export const selectIsLoading = (state: TScenarioState) => state.scenario.isLoading;
export const selectIsError = (state: TScenarioState) => state.scenario.isError;

export const selectIsAutosendAvailable = createSelector(getScenario, (scenario) => {
  if (!scenario?.step) {
    return false;
  }

  return !autosendDisabledScenarios.includes(scenario.step);
});
